module.exports = __webpack_public_path__ + "img/status-wallet.d861c13d.png";